import request from '@/api/request'

export default {
  async getProductConditions () {
    return (await request.get(`module/action/marketplace/amazon/product/conditions`)).data
  },
  async getProductTypes (account) {
    return (await request.get(`module/action/marketplace/amazon/product/getProductTypes`, {
      headers: {
        'Amazon-Account': account
      }
    })).data
  },
  async getProductTypeAttributes (productType, account, attrs = {}) {
    return (await request.post(`module/action/marketplace/amazon/product/getProductTypeAttributes/` + productType, {
      attrs
    }, { headers: {
      'Amazon-Account': account
    }})).data
  },
  async getCategories () {
    return (await request.get('module/action/marketplace/amazon/task/getCategory')).data
  },
  async getCategoryChildren (categoryParent) {
    return (await request.get(`module/action/marketplace/amazon/category/retrieve/` + categoryParent)).data
  },
  async getMatching (eans, account) {
    return (await request.post(`module/action/marketplace/amazon/product/matching`, {
      eans
    }, { headers: {
      'Amazon-Account': account
    }})).data
  },
  async getSizes () {
    return (await request.get(`module/action/marketplace/amazon/size`)).data
  },
  async getColors () {
    return (await request.get(`module/action/marketplace/amazon/color`)).data
  },
  async checkApiStatus (account) {
    try {
      await request.get(`module/action/marketplace/amazon/api/status`, {
        headers: {
          'Amazon-Account': account
        }
      })
      return true
    } catch (err) {
      return false
    }
  },
  /**
   * Retorna os dados da conta, buscando pelo código de autorização.
   *
   * @param code
   * @param sellingPartnerId
   * @param mwsAuthToken
   * @returns {Promise<*>}
   */
  async getAccount (code, sellingPartnerId, mwsAuthToken) {
    if (mwsAuthToken) {
      return (await request.get(`module/action/marketplace/amazon/account/retrieve/${code}/${sellingPartnerId}/${mwsAuthToken}`)).data
    }
    return (await request.get(`module/action/marketplace/amazon/account/retrieve/${code}/${sellingPartnerId}`)).data
  },
  /**
   * Deleta uma conta de acordo com o partnerId.
   *
   * @param partnerId
   * @returns {Promise<*>}
   */
  async deleteAccountByPartnerId (partnerId) {
    return (await request.get(`module/action/marketplace/amazon/account/deleteAccountByPartnerId/${partnerId}`)).data
  },
  /**
   * Busca as contas cadastradas conforme filtros
   *
   * @param options
   * @returns {Promise<*>}
   */
  async getAccounts (options) {
    return (await request.get(`module/action/marketplace/amazon/account/index`, {
      params: options
    })).data
  },
  /**
   * Retorna dados para autorização da conta no Amazon.
   *
   * @returns {Promise<*>}
   */
  async getAuthorization () {
    return (await request.get(`module/action/marketplace/amazon/account/getAuthorization`)).data
  },
  /**
   * Adiciona a conta no placemarket
   *
   * @param refreshToken
   * @param sellingPartnerId
   * @param mwsAuthToken
   * @returns {Promise<*>}
   */
  async addAccount (refreshToken, sellingPartnerId, mwsAuthToken) {
    if (mwsAuthToken) {
      return (await request.get(`module/action/marketplace/amazon/account/add/${refreshToken}/${sellingPartnerId}/${mwsAuthToken}`)).data
    }
    return (await request.get(`module/action/marketplace/amazon/account/add/${refreshToken}/${sellingPartnerId}`)).data
  },
  /**
   * Retorna os dados da conta, buscando pelo partnerId.
   *
   * @param partnerId
   * @returns {Promise<*>}
   */
  async getAccountByPartnerId (partnerId) {
    return (await request.get(`module/action/marketplace/amazon/account/retrieveByPartnerId/${partnerId}`)).data
  },
  /**
   * Renova o token de uma conta.
   *
   * @param {String} identifier
   * @returns {Object}
   */
  async refreshToken (identifier) {
    return (await request.get(`module/action/marketplace/amazon/account/refresh_token/${identifier}`)).data
  },
  /**
   * Atualiza o status da conta do Shopee.
   *
   * @param {String} identifier
   * @param {Boolean} status
   * @returns {Object}
   */
  async updateAccountStatus (identifier, status) {
    if (status) {
      return (await request.get(`module/action/marketplace/amazon/account/active/${identifier}`)).data
    }
    return (await request.get(`module/action/marketplace/amazon/account/inactive/${identifier}`)).data
  },
  /**
   * Atualiza o status da conta da Amazon.
   *
   * @param {String} identifier
   * @param {Boolean} status
   * @returns {Object}
   */
  async resetAccountTries (identifier) {
    return (await request.get(`module/action/marketplace/amazon/account/resetTries/${identifier}`)).data
  },
  /**
   * Sincroniza pedido por tipo e identificador do módulo e conta da Amazon.
   *
   * @param {String} type
   * @param {String} identifier
   * @param {String} code
   * @param {String} account
   * @returns {Object} Pedido sincronizado
   */
  async syncOrder (type, identifier, code, account) {
    return (await request.get(`module/action/${type}/${identifier}/order/sync/${code}`, {
      headers: {
        'Amazon-Account': account
      }
    })).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/amazon/index.js